// export const projectURL = 'http://localhost:3000/';

export const projectURL = 'https://socio-node-api-133t.onrender.com/api/'; 

// export const projectURL = 'https://api.socioapp.live/api/';

